export default "__VITE_ASSET__CjhNrCpK__"